/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

const qtiHtmlAttributes = ['id', 'class', 'role', 'dir', 'lang'];
const qtiHtmlPrefixes = ['aria', 'data'];

/**
 * Get the attributes that renders as HTML attributes
 * @param {Object} attributes - the source attributes
 * @param {String[]} [excludes] - excludes some attributes that would have been rendered
 * @returns {Object} the filtered attributes object
 */
export function htmlAttributes(attributes = {}, excludes = []) {
    return Object.keys(attributes || {})
        .filter(
            key =>
                !excludes.includes(key) &&
                (qtiHtmlAttributes.includes(key) || qtiHtmlPrefixes.some(prefix => key.startsWith(`${prefix}-`)))
        )
        .reduce((acc, key) => {
            acc[key] = attributes[key];
            return acc;
        }, {});
}
